import { addDays, endOfDay, getTimestamp, OwaDate, startOfDay } from 'owa-datetime';
import { CalendarEventKey } from 'mini-calendar-event-types';
import { createCalendarEventKey } from 'mini-calendar-events-store';
import { DAYS_TO_FETCH_FOR_PIVOT } from './agendaConstants';

/**
 * Defines the interface for Agenda pivot keys.
 */
export interface AgendaPivotKeys {
    topOfPivotKey: CalendarEventKey;
    pivotKey: CalendarEventKey;
    bottomOfPivotKey: CalendarEventKey;
}
/**
 * Generates the agenda keys based on a given pivot time.
 * @param pivotTime Time which will be used as pivot to generate the keys.
 */
export default function getAgendaKeysBasedOnPivotTime(
    pivotTime: OwaDate,
    daysToFetch: number = DAYS_TO_FETCH_FOR_PIVOT
): AgendaPivotKeys {
    let topOfPivotKey: CalendarEventKey = null;
    let pivotKey: CalendarEventKey = null;
    let bottomOfPivotKey: CalendarEventKey = null;

    if (pivotTime) {
        topOfPivotKey = createCalendarEventKey(
            getTimestamp(startOfDay(addDays(pivotTime, -daysToFetch / 2 + 1))),
            null
        );
        bottomOfPivotKey = createCalendarEventKey(
            getTimestamp(endOfDay(addDays(pivotTime, daysToFetch / 2))),
            null
        );
        pivotKey = createCalendarEventKey(getTimestamp(pivotTime), null);
    }

    return {
        topOfPivotKey,
        pivotKey,
        bottomOfPivotKey,
    };
}
